// generated from 7_589 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const customEventsFirstSinceFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("custom_events_first_since_filter"),
  // undefined: 7_570 (99.75%), defined 19 (0.25%)
  blocklisted: z.literal(true).optional(),
  comparison_key: z.enum([
    "6", // 2_850 (37.55%)
    "4", // 2_528 (33.31%)
    "3", // 1_513 (19.94%)
    "5", // 698 (9.20%)
  ]),
  display_name: z.string(),
  // undefined: 4_038 (53.21%), defined 3_551 (46.79%)
  raw_value: z
    .union([
      // number samples: 2_277 (64.12%)
      // integer: 2_178 (95.65%)
      // avg: 55.60, min: 0, max: 1096
      z.number().min(0),
      // string samples: 1_274 (35.88%)
      common.date,
    ])
    .optional(),
  value: z.union([
    // number samples: 5_378 (70.87%)
    // integer: 5_020 (93.34%)
    // avg: 46.26, min: 0, max: 1096
    z.number().min(0),
    // string samples: 2_211 (29.13%)
    common.date,
  ]),
  varies_by_app_group: z.literal(true),
});
